import React, { Component } from "react";
import {Form, Button, Container, Row, Col, Jumbotron, Alert} from "react-bootstrap";
import Axios from 'axios';
import Footer from "../Footer";
import template from "../Proposal.xlsx";

export default class AddToCampaignView extends Component{
    state = {
       campaign: {},
    };
    onSubmit = (event) => {
        event.preventDefault();
        event.stopPropagation();
        const form = event.currentTarget;
        let data = new FormData();
        data.append("boardsXlsx",form["boardsXlsx"].files[0]);
        data.append("campaignId",this.state.campaign._id);
        Axios.post(process.env.REACT_APP_BACKEND_URL + "/campaign/add-boards", data,{
            headers: {
                'content-type': 'multipart/form-data'
            }
        }).then(response => {
            form.reset();
            this.setState({campaignCreatedSuccess:true});
        }).catch(error => {
            this.setState({campaignCreatedError:error.response.data.message});
        });
    };
    dismissAlerts = (event) => {
        this.setState({campaignCreatedSuccess:undefined, campaignCreatedError:undefined})
    }

    componentWillMount() {
        this.getCampaignAPI()
    }

    getCampaignAPI(){
        let campaignId = this.props.match.params.campaignId;
        // let campaignId = this.props.match.params.campaignId;
        Axios.get(process.env.REACT_APP_BACKEND_URL + "/campaign/"+campaignId).then((response) => {
            if(response.data.message === "still looking"){
                setTimeout(()=>{
                    this.getCampaignAPI();
                },3000);
            }else{
                this.setState({campaign: response.data.campaign});
            }
        }).catch(error => {
            console.log(error);
            if(error && error.response){
                this.setState({campaignGetError:error.response.data.message});
            }
        });
    }

    render() {
        const campaignCreatedSuccess = this.state.campaignCreatedSuccess;
        const campaignCreatedError = this.state.campaignCreatedError;
        const campaignGetError = this.state.campaignGetError;
        return<div className={"main-content"}>
        <Container>
            <Jumbotron style={{maxWidth:500}} className={"mx-auto mt-5"}>
                <Form onSubmit={this.onSubmit}>
                    <Row className={"mb-2"}>
                        <Col>
                            <h2>Upload Media</h2>
                            <br/>
                            <h5 className={"font-weight-normal"}>You've been invited to upload media to the campaign: <b>{this.state.campaign.name}</b>. </h5>
                        </Col>
                    </Row>
                    <Row>
                        <Col>
                            <Form.Group controlId="boardsXlsx">
                                <Form.Label>Boards XLSX</Form.Label>
                                <Form.Control type="file" required accept=".xlsx"/>
                                <Form.Text className="text-muted">
                                    Template: <a href={template}>File</a>
                                </Form.Text>
                            </Form.Group>
                        </Col>
                    </Row>
                    <Row className={"mt-4"}>
                        <Col>
                            <Button variant="primary" type="submit">
                                + Upload
                            </Button>
                        </Col>
                    </Row>
                    <Row className={"mt-4"}>
                        <Col>
                            {/*<a className={"boring-btn"}>Manually Add a Board</a>*/}
                        </Col>
                    </Row>
                </Form>
            </Jumbotron>
            {campaignCreatedSuccess ? (
                <Alert style={{maxWidth:500}} className={"mx-auto"} variant="success" onClose={this.dismissAlerts} dismissible>
                    <Alert.Heading>Uploading to Campaign:</Alert.Heading>
                    <p>Success: Media is uploading. It will take a few minutes to
                        gather compliance and insights on your media.</p>
                </Alert>
            ):(
                <></>
            )}
            {campaignCreatedError ? (
                <Alert style={{maxWidth:500}} className={"mx-auto"}  variant="danger" onClose={this.dismissAlerts} dismissible>
                    <Alert.Heading>Error Uploading to Campaign!</Alert.Heading>
                    <p>Server Reported an Error: {campaignCreatedError}. Please try again.</p>
                </Alert>
            ):(
                <></>
            )}
            {campaignGetError ? (
                <Alert style={{maxWidth:500}} className={"mx-auto"}  variant="danger" onClose={this.dismissAlerts} dismissible>
                    <Alert.Heading>Error Uploading to Campaign!</Alert.Heading>
                    <p>Server Reported an Error: {campaignGetError}. Please try again.</p>
                </Alert>
            ):(
                <></>
            )}
            {/*<Jumbotron style={{maxWidth:500}} className={"mx-auto mt-5"}>*/}
            {/*    <Row>*/}
            {/*        <Col>*/}
            {/*            <h3>Add Train or Bus Media</h3>*/}
            {/*            <br/>*/}
            {/*            <p className={""}>Adding bus and train media follows a different format. Click "+ Add" and it will redirect you to a simple upload form.</p>*/}
            {/*        </Col>*/}
            {/*    </Row>*/}
            {/*    <Row className={"mt-4"}>*/}
            {/*        <Col>*/}
            {/*            <a href={`/campaign/${this.props.match.params.campaignId}/add-metro-media`}>*/}
            {/*                <Button variant="primary" >*/}
            {/*                    + Add*/}
            {/*                </Button>*/}
            {/*            </a>*/}

            {/*        </Col>*/}
            {/*    </Row>*/}
            {/*</Jumbotron>*/}
            <div className={"mx-auto mt-5"}>
            </div>
            <Footer/>
        </Container>
        </div>
    }
}
